const e = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M10%2010H30V30H10V10Z'%20fill='white'/%3e%3cpath%20d='M40%2020L30%2010V30L40%2020ZM20%2020L30%2010H10L20%2020ZM0%2020L10%2030V10L0%2020ZM20%2020L10%2030H30L20%2020Z'%20fill='%23DB0011'/%3e%3c/svg%3e";
export {
  e as default
};
